import React from 'react';
import Icon from '../../../components/AppIcon';


const SettingsNavigation = ({ activeSection, onSectionChange }) => {
  const navigationItems = [
    {
      id: 'profile',
      label: 'Profile',
      icon: 'User',
      description: 'Personal information and investment preferences'
    },
    {
      id: 'security',
      label: 'Security',
      icon: 'Lock',
      description: 'Password, 2FA, and login management'
    },
    {
      id: 'notifications',
      label: 'Notifications',
      icon: 'Bell',
      description: 'Alert preferences and delivery methods'
    },
    {
      id: 'app-config',
      label: 'App Settings',
      icon: 'Settings',
      description: 'Theme, currency, and display preferences'
    },
    {
      id: 'privacy',
      label: 'Privacy',
      icon: 'Shield',
      description: 'Data rights and privacy controls'
    }
  ];

  return (
    <div className="space-y-2">
      {navigationItems.map((item) => (
        <button
          key={item.id}
          onClick={() => onSectionChange(item.id)}
          className={`
            w-full flex items-center space-x-3 px-4 py-3 rounded-lg text-left
            transition-all duration-200 ease-out
            hover:bg-muted hover:text-foreground
            focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2
            ${activeSection === item.id 
              ? 'bg-primary text-primary-foreground' 
              : 'text-muted-foreground'
            }
          `}
        >
          <div className={`
            w-8 h-8 rounded-lg flex items-center justify-center
            ${activeSection === item.id 
              ? 'bg-primary-foreground/20' 
              : 'bg-muted'
            }
          `}>
            <Icon 
              name={item.icon} 
              size={16} 
              className={activeSection === item.id ? 'text-primary-foreground' : 'text-muted-foreground'}
            />
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-sm font-medium">{item.label}</div>
            <div className={`
              text-xs opacity-75 truncate
              ${activeSection === item.id ? 'text-primary-foreground' : 'text-muted-foreground'}
            `}>
              {item.description}
            </div>
          </div>
          {activeSection === item.id && (
            <div className="w-1 h-6 bg-primary-foreground rounded-full" />
          )}
        </button>
      ))}
    </div>
  );
};

export default SettingsNavigation;